import type { DetailsNavigationLayoutProps } from './data';

import { Box, Text } from '@/components';

const DetailsNavigationLayout: DetailsNavigationLayoutProps = ({
  content,
  title,
  id,
}) => {
  return (
    <Box id={id}>
      <Box
        w="max-content"
        pt={{ base: 4, md: 8 }}
        pr={{ base: '20px', md: '22px' }}
      >
        <Text
          color="black"
          py="12px"
          textAlign={{ base: 'center', md: 'right' }}
          fontSize={{ base: 'xs', md: 'lg' }}
          fontWeight={700}
        >
          {title}
        </Text>
        <Box w={{ base: '72px', md: '15' }} h="2px" bg="secondary.500"></Box>
      </Box>
      <Box pt={{ base: '5', md: '12' }} pb="14" bg="transparent">
        {content}
      </Box>
    </Box>
  );
};

export default DetailsNavigationLayout;
